import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddManufacturerModel, UpdateManufacturerModel } from '../../../pages/look-up-tables/look-up-tables.model';
import { LookUpTablesService } from '../../../pages/look-up-tables/look-up-tables.service';
import { ToastrService } from 'ngx-toastr';
import { CommonDropdownModel } from 'src/app/components/crm/companies/pop-ups/add-company/add-company.model';
import { CommonTabService } from 'src/app/shared/services/common-tab.service';
import { Button } from 'src/app/shared/model/enum';

@Component({
  selector: 'app-add-edit-manufacturer',
  templateUrl: './add-edit-manufacturer.component.html',
  styleUrls: ['./add-edit-manufacturer.component.scss']
})
export class AddEditManufacturerComponent implements OnInit {
  @Input() title:string;
  @Input() manufacturerModelInsertUpdate = new AddManufacturerModel();
  @Input() updateManufacturerModel = new UpdateManufacturerModel();
  manufacturerList              : CommonDropdownModel[] = [];
  primaryManufacturerList         : CommonDropdownModel[] = [];
  submit                        : boolean =false;
  enumButtonName = Button;
  showDropdown: boolean = false;
  @Input() dropdownList: { selectedValue: any }[] = [{ selectedValue: null }]
  @Input() data:any = {};
  constructor(    
    public  activeModal : NgbActiveModal, 
    public lookUpTablesService:LookUpTablesService,
    public toaster : ToastrService,
    public commonTabService: CommonTabService) { }

  ngOnInit(): void {
    if(this.data?.addRelatedEntity){
      this.manufacturerModelInsertUpdate.manufacturerName = this.data?.addManufacturerModel?.manufacturerName;
      this.manufacturerModelInsertUpdate.isSubManufacturer = true;
    }
    this.getManufacturerLists();
  }

  getManufacturerLists(){
    this.commonTabService.getAllDropDownList().subscribe(res => {
      if (this.data?.addRelatedEntity) {
        const labelName = this.data?.addManufacturerModel?.manufacturerName;
        this.primaryManufacturerList = res?.response?.primaryManufacturerList?.filter(item => item?.name !== labelName);
      } else {
        this.primaryManufacturerList = res?.response?.primaryManufacturerList;
      }
      this.manufacturerList = res?.response?.manufacturerList;
    })
  }
  addManufacturer(){
    if(this.manufacturerModelInsertUpdate.manufacturerName){
      this.lookUpTablesService.addManufacturer(this.manufacturerModelInsertUpdate).subscribe((res) =>{
     if(res.isSuccess){
       this.toaster.success(res.message);
       this.activeModal.close({ isSuccess: true, response : res});
     }
     }); 
     }else{
       this.submit =true;
       this.toaster.error('Input filed required')
     }
  }
  addRelatedEntityManufacturer(){
    if(this.manufacturerModelInsertUpdate?.manufacturerId?.length == 0){
      this.toaster.error('Please select manufacturer.')
      return
    }
    let requestData =  {
      primaryManufacturerId: this.data?.addManufacturerModel?.manufacturerId,
      manufacturerId: this.manufacturerModelInsertUpdate.manufacturerId,
      isSubManufacturer: true
      }
      this.lookUpTablesService.addRelatedEntityManufacturer(requestData).subscribe((res) =>{
     if(res.isSuccess){
       this.toaster.success(res.message);
       this.activeModal.close(res);
     }
     }); 
     
  }

  updateManufacturer(){
    if(this.updateManufacturerModel.manufacturerName){
      this.updateManufacturerModel.manufacturerId = [this.data?.updateManufacturerModel?.manufacturerId];
      this.updateManufacturerModel.masterManufacturerChildId = this.data?.updateManufacturerModel?.masterManufacturerChildId;
      this.updateManufacturerModel.manufacturerTypeId = this.data?.manufacturerType;
      this.lookUpTablesService.updateManufacturer(this.updateManufacturerModel).subscribe((res) =>{
     if(res.isSuccess){
       this.toaster.success(res.message);
       this.activeModal.close(res);
     }
     }); 
     }else{
       this.submit =true;
       this.toaster.error('Input filed required')
     }
  }

  linkAdditional() {
    this.dropdownList.push({ selectedValue: null });
  }
  deleteDropdown(index: number) {
    if (index > 0 && index < this.dropdownList.length) {
      this.dropdownList.splice(index, 1);
      this.manufacturerModelInsertUpdate?.manufacturerId?.splice(index, 1);
    }
    }
  clearDropdownValue(index: number) {
    if (index >= 0 && index < this.dropdownList.length) {
      this.dropdownList[index].selectedValue = null;
      this.manufacturerModelInsertUpdate?.manufacturerId?.splice(index, 1);
    }  }
  onDropdownValueChange(index: number, value: any): void {
    this.dropdownList[index].selectedValue = value;
  }

  onCheckboxChange(event: any): void {
    this.manufacturerModelInsertUpdate.isSubManufacturer = event;
    this.manufacturerModelInsertUpdate.manufacturerId = []; 
    this.dropdownList =[]
    this.dropdownList.push({ selectedValue: null });
  }
   selecteddata:string[] = [];
   selectedValue(id: string, index: number) {
    if (!this.selecteddata.includes(id)) {
      if (this.selecteddata.length > index) {
        this.selecteddata[index] = id;
      } else {
        this.selecteddata.push(id); 
      }
      this.manufacturerModelInsertUpdate.manufacturerId = [...this.selecteddata]; 
    }
  }
  
  addNewRecord(name){
    if(!name)return
    const requestData = { name:name,isActive:true}
    this.lookUpTablesService.addPrimaryManufacturer(requestData).subscribe((res) =>{
      if(res.isSuccess){
        this.toaster.success(res.message);
        this.getManufacturerLists();
      }
      }); 
  }
  onchange(event){
  }
}
